export const dateAsString = (date: Date) => {
  if (!date) {
    return '-';
  }
  date = new Date(date);
  const m = date.getUTCMonth() + 1;
  const d = date.getUTCDate();
  const y = date.getUTCFullYear();
  return `${m < 10 ? '0' : ''}${m}-${d < 10 ? '0' : ''}${d}-${y}`;
};

export const dateTimeAsString = (date: Date) => {
  if (!date) {
    return '-';
  }
  date = new Date(date);
  const m = date.getMonth() + 1;
  const d = date.getDate();
  const y = date.getFullYear();
  let h = date.getHours();
  const min = date.getMinutes();
  const ampm = h >= 12 ? 'PM' : 'AM';
  h = h % 12;
  h = h ? h : 12; // the hour '0' should be '12'
  return `${m < 10 ? '0' : ''}${m}-${d < 10 ? '0' : ''}${d}-${y} / ${h}:${min < 10 ? '0' : ''}${min} ${ampm}`;
};

export const dateTimeWithTimezoneAsString = (date: Date) => {
  if (!date) {
    return '-';
  }
  date = new Date(date);
  const m = date.getMonth() + 1;
  const d = date.getDate();
  const y = date.getFullYear();
  let h = date.getHours();
  const min = date.getMinutes();
  const ampm = h >= 12 ? 'PM' : 'AM';
  h = h % 12;
  h = h ? h : 12;
  const dateTime = `${m < 10 ? '0' : ''}${m}-${d < 10 ? '0' : ''}${d}-${y} / ${h}:${min < 10 ? '0' : ''}${min} ${ampm}`;

  // getTimezoneOffset() is (UTC - local) in minutes
  const offsetMinutes = -date.getTimezoneOffset();
  const sign = offsetMinutes >= 0 ? '+' : '-';
  const absMinutes = Math.abs(offsetMinutes);
  const offsetHours = Math.floor(absMinutes / 60);
  const offsetMins = absMinutes % 60;
  const tz =
    offsetMins === 0
      ? `UTC${sign}${offsetHours}`
      : `UTC${sign}${offsetHours}:${offsetMins < 10 ? '0' : ''}${offsetMins}`;
  return `${dateTime} ${tz}`;
};

export const monthAsShortString = (date: Date) => {
  const mlist = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return mlist[date.getUTCMonth()];
};

export const dayAsString = (date: Date) => {
  date = new Date(date);
  return date.getUTCDate() + '';
};
